import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

/**
 * Renders a plain string, converting inline markdown-style links
 * `[text](href)` into <Link> (for internal /paths) or <a> (external).
 * Everything else is passed through as text.
 */
export function InlineText({ text }: { text: string }) {
  const nodes: ReactNode[] = [];
  const re = /\[([^\]]+)\]\(([^)]+)\)/g;
  let last = 0;
  let m: RegExpExecArray | null;
  let key = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    const [, label, href] = m;
    if (href.startsWith("/")) {
      nodes.push(
        <Link
          key={key++}
          to={href}
          className="text-pink-soft underline underline-offset-2 hover:text-white transition-colors"
        >
          {label}
        </Link>,
      );
    } else {
      nodes.push(
        <a
          key={key++}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-pink-soft underline underline-offset-2 hover:text-white transition-colors"
        >
          {label}
        </a>,
      );
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return <>{nodes}</>;
}
